import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useAppStore } from '@/hooks/useAppStore'
import { WelcomeScreen } from '@/pages/WelcomeScreen'
import { ModeScreen } from '@/pages/ModeScreen'
import { QuizScreen } from '@/pages/QuizScreen'
import { DnaScreen } from '@/pages/DnaScreen'
import { JourneyScreen } from '@/pages/JourneyScreen'
import { GateScreen } from '@/pages/GateScreen'
import { JourneyCardScreen } from '@/pages/JourneyCardScreen'
import { FullItineraryScreen } from '@/pages/FullItineraryScreen'

const PAGE_VARIANTS = {
  initial: { opacity: 0, scale: 0.97, y: 10 },
  animate: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.35, ease: [0.34, 1.56, 0.64, 1] } },
  exit: { opacity: 0, scale: 0.98, y: -6, transition: { duration: 0.2 } },
}

export default function App() {
  const screen = useAppStore((s) => s.screen)

  return (
    <div className="min-h-screen bg-cream font-display">
      <AnimatePresence mode="wait">
        <motion.div
          key={screen}
          variants={PAGE_VARIANTS}
          initial="initial"
          animate="animate"
          exit="exit"
          className="min-h-screen"
        >
          {screen === 'welcome' && <WelcomeScreen />}
          {screen === 'mode' && <ModeScreen />}
          {screen === 'quiz' && <QuizScreen />}
          {screen === 'dna' && <DnaScreen />}
          {screen === 'journey' && <JourneyScreen />}
          {screen === 'gate' && <GateScreen />}
          {screen === 'card' && <JourneyCardScreen />}
          {screen === 'itinerary' && <FullItineraryScreen />}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
